/* eslint-disable no-param-reassign */
import produce from 'immer';
var cellSetsClusteringUpdating = produce(function (draft) {
  draft.updatingClustering = true;
  draft.loading = true;
});
export default cellSetsClusteringUpdating;